export enum API_TYPES {
  MT_API_URL = 'MT_API_URL',
}

const developmentApi: Record<API_TYPES, string> = {
  MT_API_URL: 'https://mt-pg3-poc.coke.com/v2',
}

const productionApi: Record<API_TYPES, string> = {
  MT_API_URL: 'MT_API_URL',
}

const config = Object.keys(API_TYPES).reduce(
  (acc, type) => {
    const api =
      process.env.NODE_ENV !== 'development'
        ? process.env[`REACT_APP_${type}`] || productionApi[type as API_TYPES]
        : developmentApi[type as API_TYPES]
    return { ...acc, [type]: api }
  },
  {} as Record<API_TYPES, string>,
)

export default config
